export const RadioListQcFieldName = 'radioListQcFieldComponent';
